/**
 * @file dots.icon.tsx
 * @description Компонент для отображения троеточия.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const DotsIcon = ({ className, size = '2.1171vmin', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.66663 8C3.66663 7.44772 3.21891 7 2.66663 7C2.11434 7 1.66663 7.44772 1.66663 8C1.66663 8.55228 2.11434 9 2.66663 9C3.21891 9 3.66663 8.55228 3.66663 8ZM14.3333 8C14.3333 7.44772 13.8856 7 13.3333 7C12.781 7 12.3333 7.44772 12.3333 8C12.3333 8.55228 12.781 9 13.3333 9C13.8856 9 14.3333 8.55228 14.3333 8ZM8.99997 8C8.99997 7.44772 8.55225 7 7.99997 7C7.44769 7 6.99997 7.44772 6.99997 8C6.99997 8.55228 7.44769 9 7.99997 9C8.55225 9 8.99997 8.55228 8.99997 8Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
